/**
 * @file The select account identities component.
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import SelectAccountIdentityContainer from '../../containers/purchase/SelectAccountIdentityContainer';
import CreateAccountIdentityContainer from '../../apps/consumer/containers/CreateAccountIdentityContainer';
import UpdateAccountIdentityContainer from '../../apps/consumer/containers/UpdateAccountIdentityContainer';
import { CREATE_ACCOUNT_IDENTITY_MODAL } from '../../constants/modals';
import { getAsset } from '../../util/assets';
import {
  getAccountIdentityNamesArray,
  identitiesFilteredOnAccess,
} from '../../util/identity';
import { ALBUM_IDENTITY_ACCESS } from '../../constants/identity';
import ContextualString from '../contextual/ContextualString';

class SelectAccountIdentities extends Component {
  static propTypes = {
    identities: PropTypes.arrayOf(PropTypes.object),
    joinedIdentities: PropTypes.arrayOf(PropTypes.object),
    purchasedIdentities: PropTypes.arrayOf(PropTypes.object),
    selectedIdentitiesForPurchase: PropTypes.arrayOf(PropTypes.object),
    selectedIdentitiesForJoin: PropTypes.arrayOf(PropTypes.object),
    openModal: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    album: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      display_name: PropTypes.string,
    }),

    location: PropTypes.shape({
      state: PropTypes.shape({
        forcePurchase: PropTypes.bool,
      }),
    }),
  };

  onAddFace = event => {
    event.preventDefault();

    this.props.openModal(CREATE_ACCOUNT_IDENTITY_MODAL);
  };

  renderIdentity(identity) {
    const {
      selectedIdentitiesForPurchase,
      selectedIdentitiesForJoin,
      purchasedIdentities,
      joinedIdentities,
      album,
      location,
    } = this.props;

    const isSelectedForPurchase =
      selectedIdentitiesForPurchase &&
      !!selectedIdentitiesForPurchase.find(
        selectedIdentity => selectedIdentity.id === identity.id,
      );
    const isSelectedForJoin =
      isSelectedForPurchase ||
      (selectedIdentitiesForJoin &&
        !!selectedIdentitiesForJoin.find(
          selectedIdentity => selectedIdentity.id === identity.id,
        ));
    const isPurchased =
      purchasedIdentities &&
      !!purchasedIdentities.find(
        purchasedIdentity => purchasedIdentity.id === identity.id,
      );
    const isJoined =
      joinedIdentities &&
      !!joinedIdentities.find(
        selectedIdentity => selectedIdentity.identity.id === identity.id,
      );

    return (
      <SelectAccountIdentityContainer
        key={identity.id}
        identity={identity}
        isSelectedForPurchase={isSelectedForPurchase}
        isSelectedForJoin={isSelectedForJoin}
        isPurchased={isPurchased}
        isJoined={isJoined}
        album={album}
        forcePurchase={get(location, 'state.forcePurchase', false)}
      />
    );
  }

  render() {
    const { identities, loading, album } = this.props;

    const filteredIdentities = identitiesFilteredOnAccess(
      identities,
      get(album, 'primary_identities_only', false)
        ? ALBUM_IDENTITY_ACCESS.PRIMARY_ONLY
        : ALBUM_IDENTITY_ACCESS.ALL,
    );

    return (
      <Fragment>
        {loading ? (
          <div className="d-block text-center">
            <span className="spinner" />
          </div>
        ) : (
          <div className="flex-list">
            {(filteredIdentities || []).map(identity =>
              this.renderIdentity(identity),
            )}
            {!get(album, 'primary_identities_only', false) && (
              <div className="flex-list-item">
                <button
                  onClick={this.onAddFace}
                  className="btn-reset text-primary"
                >
                  <img
                    src={getAsset('/icon-add-face.svg')}
                    alt=""
                    className="mr-2"
                    width="42"
                    height="42"
                  />

                  <ContextualString
                    id="consumerAddNewIdentity"
                    defaultMessage="Add new family member"
                    type={get(album, 'album_type')}
                    subtype={get(album, 'album_subtype')}
                  />
                </button>
              </div>
            )}
          </div>
        )}

        <CreateAccountIdentityContainer
          stringContext={album}
          identityNames={getAccountIdentityNamesArray(identities ?? [])}
          requiresSelfieChecklistVerification
        />
        <UpdateAccountIdentityContainer
          stringContext={album}
          requiresSelfieChecklistVerification
        />
      </Fragment>
    );
  }
}

export default SelectAccountIdentities;
